import React from 'react';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import DraftJsDropdownButton from './DraftJsDropdownButton';
import calloutSVG from '@plone/volto/icons/megaphone.svg';

const CalloutsButton = (props) => {
  const createBlockStyleButton = props.draftJsCreateBlockStyleButton.default;

  const blockTypes = [
    { type: 'callout', label: 'Trasparente', className: '' },
    { type: 'callout-bg-cyan', label: 'Ciano', className: 'bg-cyan' },
    {
      type: 'callout-bg-light-red',
      label: 'Rosso',
      className: 'bg-light-red',
    },
    { type: 'callout-bg-peach', label: 'Pesca', className: 'bg-peach' },
    {
      type: 'callout-bg-light-green',
      label: 'Verde',
      className: 'bg-light-green',
    },
    {
      type: 'callout-bg-light-grey',
      label: 'Grigio',
      className: 'bg-light-grey',
    },
  ];

  const options = blockTypes.map(({ type, label, className }) => ({
    block_type: type,
    value: createBlockStyleButton({
      blockType: type,
      children: (
        <span className={`callout-icon ${className}`.trim()}>{label}</span>
      ),
    }),
  }));

  return (_props) => (
    <DraftJsDropdownButton
      {..._props}
      optionsList={options}
      content={<Icon name={calloutSVG} size="24px" />}
    />
  );
};

export default CalloutsButton;
